import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './PlacementEventDetails.redux';

const selectDomain = (state: RootState) => state?.placementEventDetails || initialState;

export const PlacementEventsSelection = createSelector([selectDomain], details => details.events);
export const PlacementRequirementsSelection = createSelector([selectDomain], details => details.requirements);
export const PlacementEventTypesSelection = createSelector([selectDomain], details => details.types);
export const PlacementCategorySelection = createSelector([selectDomain], details => details.selectedCategory);
export const PlacementGridSelection = createSelector([selectDomain], details => details.selectedPlacementGrid);

export const PlacementEventLoadingSelection = createSelector([selectDomain], details => details.loading);
export const PlacementEventErrorSelection = createSelector([selectDomain], details => details.error);
export const PlacementEventIsSuccessSelection = createSelector([selectDomain], details => details.isSuccess);

export const PlacementRequirementsCheckListsSelection = createSelector([selectDomain], details => details.checkList);
export const PlacementDialogLoadingSelection = createSelector([selectDomain], details => details.loadingDialog);
export const PlacementRequirementsReload = createSelector([selectDomain], details => details.reloadData);

export const ExceptionWaiveSelection = createSelector([selectDomain], details => details.exceptionWave);
export const DeletedAttachmentsSelection = createSelector([selectDomain], details => details.deletedAttachments);
export const ExceptionWaveNewAttachmentSelection = createSelector(
  [selectDomain],
  details => details.exceptionWaveNewAttachment,
);
export const AttachmentItemStateSelection = createSelector([selectDomain], details => details.AttachmentItemState);
export const AttachmentErrorMessageSelection = createSelector(
  [selectDomain],
  details => details.AttachmentErrorMessage,
);
export const ExceptionWaveIsDeletedSelection = createSelector([selectDomain], details => details.Notify);
export const ExceptionDialogStateSelection = createSelector([selectDomain], details => details.exceptionDialogState);
